import { useEffect } from "react";
import Animated, { useAnimatedStyle, useSharedValue, withTiming } from "react-native-reanimated";
import TouchableScale from "src/components/TouchableScale";
import cursor from "src/constants/cursor";
import useEditCoverGalleryStore from "src/screens/(internal)/EditCoverGalleryModal/hooks/useEditCoverGalleryStore";
import { EditCoverGalleryTabConfig } from "src/screens/(internal)/EditCoverGalleryModal/types";
import { paddingLarge, paddingMedium } from "src/styles/spacing";
import { Text } from "src/swsh-native";
import getTabName from "../helpers/getTabName";

const baseOpacity = 0.5;
export const editCoverTabHorizontalPadding = paddingLarge;
const editCoverTabVerticalPadding = paddingMedium;
const EditCoverTabItem = ({
	config,
	onWidthCalculated,
}: {
	config: EditCoverGalleryTabConfig;
	onWidthCalculated?: (width: number) => void;
}) => {
	const hoverProgressSV = useSharedValue(0);
	const isSelected = useEditCoverGalleryStore(
		(state) => state.selectedTab?.itemKey === config.itemKey,
	);
	const focusProgressSV = useSharedValue(+isSelected);
	useEffect(() => {
		if (isSelected) {
			focusProgressSV.value = withTiming(1);
		} else {
			focusProgressSV.value = withTiming(0);
		}
	}, [focusProgressSV, isSelected]);
	const selectTab = useEditCoverGalleryStore((state) => state.selectTab);

	const animatedStyle = useAnimatedStyle(
		() => ({
			opacity:
				baseOpacity +
				(1 - baseOpacity) * Math.max(0.2 * hoverProgressSV.value, focusProgressSV.value),
		}),
		[hoverProgressSV, focusProgressSV],
	);
	return (
		<TouchableScale
			onPress={() => {
				selectTab(config);
			}}
		>
			<Animated.View
				onLayout={(event) => {
					onWidthCalculated?.(event.nativeEvent.layout.width);
				}}
				style={[
					animatedStyle,
					{
						cursor: cursor.pointer,
						paddingHorizontal: editCoverTabHorizontalPadding,
						paddingVertical: editCoverTabVerticalPadding,
					},
				]}
			>
				<Text semibold>{getTabName(config)}</Text>
			</Animated.View>
		</TouchableScale>
	);
};
export default EditCoverTabItem;
